import {initABTestingInstance} from "@web2/ab_testing";

import {ghCommonUrl} from "../app/utils/read_environment_variables";
import {ongoingABTests} from "./ongoing_ab_tests";

const domain = new URL(ghCommonUrl).hostname;

export const abTestingInstance = initABTestingInstance(ongoingABTests, {domain});
